import { ProfileGender } from '@watcherr/resources';
import { t } from '~/i18n';

export const genders = [
  {
    value: ProfileGender.Male,
    label: t('global.male'),
  },
  {
    value: ProfileGender.Female,
    label: t('global.female'),
  },
];

export const teams = [
  {
    value:["Admin HCP Team"],
    label:t("global.team.admin")
  },
  {
    value:[],
    label:t("global.team.staff")
  }
]
